export default __webpack_public_path__ + "static/pizzeria-team-b2a94c3af8da0d2b5d1f575cb1e0fda9.webp";